export enum GetFamilyIncomesConst {
  GET_FAMILY_INCOMES = 'GET:FAMILY_INCOMES',
  GET_FAMILY_INCOMES_OK = 'GET:FAMILY_INCOMES:OK',
  GET_FAMILY_INCOMES_KO = 'GET:FAMILY_INCOMES:KO',
  OPEN_INCOME_MODAL = 'OPEN:INCOME:MODAL',
  CLOSE_INCOME_MODAL = 'CLOSE:INCOME:MODAL',
}
